import { z } from 'zod';

const vaultDiskSchema = z.object({
  total: z.string(),
  used: z.string(),
  free: z.string(),
  percentUsed: z.number(),
});

const vaultEnvInfoSchema = z.object({
  appEnv: z.string(),
  apiKeyMasked: z.string(),
  nodeEnv: z.string(),
});

const vaultReframeSchema = z.object({
  available: z.boolean(),
  pythonVersion: z.string().nullable(),
  insightface: z.boolean(),
  mediapipe: z.boolean(),
  error: z.string().nullable(),
});

export const vaultHealthResponseSchema = z.object({
  platform: z.string(),
  ffmpegVersion: z.string(),
  nvencAvailable: z.boolean(),
  codec: z.string(),
  uptimeSeconds: z.number(),
  vaultPath: z.string(),
  disk: vaultDiskSchema,
  s3Connected: z.boolean().optional(),
  s3Error: z.string().optional(),
  envInfo: vaultEnvInfoSchema.optional(),
  reframe: vaultReframeSchema.optional(),
});

export type IVaultHealthResponse = z.infer<typeof vaultHealthResponseSchema>;
